import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

import SEO from "../../../data/seo";
import HeaderTwo from "../../../layout/headers/header-two";
import FooterTwo from "../../../layout/footers/footer-two";
import BreadCrumb from "../../common/breadcrumb";
import PortfolioDetailsMain from "./portfolio-details";
import {getPortfolios, getServices} from "../../../utils/cms.utils";

const PortfolioDetails = () => {
    const {id} = useParams();
    const navigate = useNavigate();

    const [dataList, setDataList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [services, setServices] = useState(null);

    useEffect(() => {
        let mounted = true;

        const fetchPortfolios = async () => {
            try {
                setLoading(true);

                const res = await getPortfolios();
                const items = Array.isArray(res) ? res : [];

                if (mounted) {
                    setDataList(
                        [...items].sort((a, b) => (b.orderNo ?? 0) - (a.orderNo ?? 0))
                    );
                }

                const serviceData = getServices();
                const sorted = Array.isArray(serviceData)
                    ? [...serviceData].sort(
                        (a, b) => (a.orderNo ?? 0) - (b.orderNo ?? 0)
                    )
                    : [];
                setServices(sorted);
            } catch (error) {
                console.error("Portfolio fetch error:", error);
                if (mounted) {
                    navigate("/404-error", {replace: true});
                }
            } finally {
                if (mounted) setLoading(false);
            }
        };

        fetchPortfolios();

        return () => {
            mounted = false;
        };
    }, [navigate]);

    const singleData = dataList.find(
        (item) => String(item.id) === String(id)
    );

    useEffect(() => {
        if (!loading && dataList.length > 0 && !singleData) {
            navigate("/404-error", {replace: true});
        }
    }, [loading, dataList, singleData, navigate]);

    if (loading || !dataList.length || !singleData) return null;

    const breadcrumbTitle =
        singleData.title?.split(" ").slice(0, 3).join(" ") + "...";

    return (
        <>
            <SEO pageTitle={singleData.title}/>
            <HeaderTwo/>

            <BreadCrumb
                title={breadcrumbTitle}
                items={[
                    {label: "Portfolio", to: "/portfolio"},
                    {label: singleData.title},
                ]}
            />

            <PortfolioDetailsMain
                dataList={dataList}
                singleData={singleData}
                services={services}
            />
            <FooterTwo/>
        </>
    );
};

export default PortfolioDetails;
